module.exports = __webpack_public_path__ + "static/media/material-silver.891823fe.svg";